import React from 'react';
import Page from '../components/Page';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import { Button, Card, CardBody, Col, Row, Table, Modal } from 'reactstrap';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';
import axios from 'axios';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import ConfigurationForm from '../components/ConfigurationForm';

class ConfigurationPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      zoUserList: [],
      redirect: false,
      email: '',
    };
  }

  toggle = email => () => {
    return this.setState({
      modal: !this.state.modal,
      email: email === '' || email === undefined ? '' : email,
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getZoUserList();
    }
  };

  remove = id => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      AuthorisedKey: id,
    };

    axios
      .post(url + ':3000/v1/configuration/delete', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'ZoUser removed successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ modal: false });
        this.getZoUserList();
      })
      .catch(error => {
        alert(error);
      });
  };

  getZoUserList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: org.CompanyID,
    };

    axios
      .post(url + ':3000/v1/configuration/get', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ zoUserList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    if (StorageService.getSession('selected_org') === null) {
      this.setState({
        redirect: true,
      });
    } else {
      this.getZoUserList();
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <Page
        className="ConfigurationPage"
        title="Configuration"
        breadcrumbs={[{ name: 'Configuration', active: true }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <div className="text-right mb-4">
                  <Button
                    className="theme-button theme-button-primary"
                    onClick={this.toggle()}
                  >
                    Invite User
                  </Button>
                </div>
                <Table responsive hover className="ps-table tb-col-5">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Service</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.zoUserList.length < 1 && (
                      <tr>
                        <td colSpan="4">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                              <span>
                                Click the 'Invite User' button to add Zo user
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.zoUserList.length > 0 &&
                      this.state.zoUserList.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.Email}</td>
                            <td>{item.Service}</td>
                            <td>
                              <span
                                className={
                                  'ps-indicator ' +
                                  (item.Status == 'Linked' ? 'on' : 'off')
                                }
                              >
                                {item.Status}
                              </span>
                            </td>
                            <td>
                              <div className="ps-action-button">
                                {item.Status === 'Linked' && (
                                  <Button
                                    color="link"
                                    className="theme-button theme-button-primary-light"
                                    onClick={() =>
                                      this.remove(item.AuthorisedKey)
                                    }
                                  >
                                    Remove
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <ConfigurationForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            data={this.state}
          />
        </Modal>
      </Page>
    );
  }
}
export default ConfigurationPage;
